mutation CreateInterval($input: RateIntervalInputType!) {
  createRateInterval(input: $input) {
    result
    messages {
      message
      severity
      field
    }
      payload
  }
}

query RateInterval($id: ID!) {
    rateInterval(id: $id) {
        id
        name
        description
        type
        archived
        settings
        ratelists {
            id
            name
        }
    }
}

mutation EditInterval($id: ID!, $input: RateIntervalInputType!) {
    editRateInterval(id: $id, input: $input) {
        messages {
            field
            message
            severity
        }
        result
    }
}


mutation DeleteInterval($id: ID!) {
    deleteRateInterval(id: $id) {
        messages {
            field
            message
            severity
        }
        result
    }
}
